import { BannerVideoData } from '../typings/bannersEditState';
import { EditorPlaceId } from '../typings/common';
import { VideoState } from '../typings/video';

export const UPDATE_VIDEOS = 'UPDATE_VIDEOS';
export type UPDATE_VIDEOS = typeof UPDATE_VIDEOS;

export const OPEN_VIDEO_CONSTRUCTOR = 'OPEN_VIDEO_CONSTRUCTOR';
export type OPEN_VIDEO_CONSTRUCTOR = typeof OPEN_VIDEO_CONSTRUCTOR;

export const OPEN_VIDEO_CONSTRUCTOR_WITH_CPC_VIDEO =
    'OPEN_VIDEO_CONSTRUCTOR_WITH_CPC_VIDEO';
export type OPEN_VIDEO_CONSTRUCTOR_WITH_CPC_VIDEO = typeof OPEN_VIDEO_CONSTRUCTOR_WITH_CPC_VIDEO;

export const CLOSE_VIDEO_CONSTRUCTOR = 'CLOSE_VIDEO_CONSTRUCTOR';
export type CLOSE_VIDEO_CONSTRUCTOR = typeof CLOSE_VIDEO_CONSTRUCTOR;

export const UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID =
    'UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID';
export type UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID = typeof UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID;

export const UPDATE_BANNER_VIDEO_CREATIVE_ID =
    'UPDATE_BANNER_VIDEO_CREATIVE_ID';
export type UPDATE_BANNER_VIDEO_CREATIVE_ID = typeof UPDATE_BANNER_VIDEO_CREATIVE_ID;

export const UPDATE_BANNER_VIDEO_DATA = 'UPDATE_BANNER_VIDEO_DATA';
export type UPDATE_BANNER_VIDEO_DATA = typeof UPDATE_BANNER_VIDEO_DATA;

export const REMOVE_BANNER_VIDEO = 'REMOVE_BANNER_VIDEO';
export type REMOVE_BANNER_VIDEO = typeof REMOVE_BANNER_VIDEO;

export interface UpdateVideos {
    type: UPDATE_VIDEOS;
    data: VideoState;
}

export function updateVideos(data: VideoState): UpdateVideos {
    return {
        type: UPDATE_VIDEOS,
        data
    };
}

export interface OpenVideoConstructor {
    type: OPEN_VIDEO_CONSTRUCTOR;
    id: EditorPlaceId;
}
export function openVideoConstructor(id: EditorPlaceId): OpenVideoConstructor {
    return {
        type: OPEN_VIDEO_CONSTRUCTOR,
        id
    };
}

export interface OpenVideoConstructorWithCpcVideo {
    type: OPEN_VIDEO_CONSTRUCTOR_WITH_CPC_VIDEO;
    id: EditorPlaceId;
}

export function openVideoConstructorWithCpcVideo(
    id: EditorPlaceId
): OpenVideoConstructorWithCpcVideo {
    return {
        type: OPEN_VIDEO_CONSTRUCTOR_WITH_CPC_VIDEO,
        id
    };
}

export interface CloseVideoConstructor {
    type: CLOSE_VIDEO_CONSTRUCTOR;
    id: EditorPlaceId;
}
export function closeVideoConstructor(
    id: EditorPlaceId
): CloseVideoConstructor {
    return {
        type: CLOSE_VIDEO_CONSTRUCTOR,
        id
    };
}

export interface UpdateBannerCpcVideoCreativeId {
    type: UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID;
    id: EditorPlaceId;
    creativeId: string;
}

export function updateBannerCpcVideoCreativeId(
    id: EditorPlaceId,
    creativeId: string
): UpdateBannerCpcVideoCreativeId {
    return {
        type: UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID,
        id,
        creativeId
    };
}

export interface UpdateBannerVideoCreativeId {
    type: UPDATE_BANNER_VIDEO_CREATIVE_ID;
    id: EditorPlaceId;
    creativeId: string;
}
export function updateBannerVideoCreativeId(
    id: EditorPlaceId,
    creativeId: string
): UpdateBannerVideoCreativeId {
    return {
        type: UPDATE_BANNER_VIDEO_CREATIVE_ID,
        id,
        creativeId
    };
}

export interface UpdateBannerVideoData {
    type: UPDATE_BANNER_VIDEO_DATA;
    data: BannerVideoData;
    id: EditorPlaceId;
}
export function updateBannerVideoData(
    data: BannerVideoData,
    id: EditorPlaceId
): UpdateBannerVideoData {
    return {
        type: UPDATE_BANNER_VIDEO_DATA,
        data,
        id
    };
}

export const ON_CLOSE_VIDEO_CONSTRUCTOR = 'ON_CLOSE_VIDEO_CONSTRUCTOR';
export type ON_CLOSE_VIDEO_CONSTRUCTOR = typeof ON_CLOSE_VIDEO_CONSTRUCTOR;
export interface OnCloseVideoConstructor {
    type: ON_CLOSE_VIDEO_CONSTRUCTOR;
    id: EditorPlaceId;
}
export function onCloseVideoConstructor(
    id: EditorPlaceId
): OnCloseVideoConstructor {
    return {
        type: ON_CLOSE_VIDEO_CONSTRUCTOR,
        id
    };
}

export interface BannerVideoRemove {
    type: REMOVE_BANNER_VIDEO;
    id: EditorPlaceId;
}
export function bannerVideoRemove(id: EditorPlaceId): BannerVideoRemove {
    return {
        type: REMOVE_BANNER_VIDEO,
        id
    };
}

export type VideoActions =
    | UpdateVideos
    | OpenVideoConstructor
    | OpenVideoConstructorWithCpcVideo
    | CloseVideoConstructor
    | UpdateBannerCpcVideoCreativeId
    | UpdateBannerVideoCreativeId
    | UpdateBannerVideoData
    | OnCloseVideoConstructor
    | BannerVideoRemove;
